<app-card [title]="title" titleSize="large" height="initial">
    <ng-template #content>
        <div class="grid-6col input-grid-gaps">
            <div class="grid-2col input-grid-gaps fr-3">
                <app-select-input
                    id="usage"
                    [form]="form"
                    label="service.patterns.document.add.usage"
                    [staticOptions]="servicePatternUsageEnumOptions"
                    valueKey="value"
                    [autoDisplayFirst]="false">
                </app-select-input>
                <app-text-input [form]="form" id="name" label="service.patterns.structure.fields.name"></app-text-input>
            </div>
            <app-date-input [form]="form" id="validFrom"></app-date-input>
            <app-date-input [form]="form" id="validTo"></app-date-input>
            <div class="fr-6">
                <app-text-input [form]="form" id="note"></app-text-input>
            </div>
            <div class="fr-6">
                <p>{{ 'service.patterns.document.add.patternTitle' | translate }}</p>
                <app-input-wysiwyg
                    [form]="form"
                    id="content"
                    [autocompleteOrganization]="true"
                    editorKey="ServicesPatternsDocumentContent"
                    [patternGroups]="[WysiwygPlaceholderGroupEnum.SERVICE, WysiwygPlaceholderGroupEnum.ORGANIZATION]"
                ></app-input-wysiwyg>
                <app-wysiwyg-placeholder-info
                    [groups]="[WysiwygPlaceholderGroupEnum.SERVICE, WysiwygPlaceholderGroupEnum.ORGANIZATION]"
                    [expanded]="true"
                    [showHandleBarInfo]="false"
                ></app-wysiwyg-placeholder-info>
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <app-action-buttons [primaryButtonVisibility]="form.enabled" (primaryClickEvent)="submit()"
            secondaryButtonType="return"></app-action-buttons>
    </ng-template>
</app-card>
